import {message} from "antd";
import axios, {AxiosError} from "axios";
import {FormatResponseDataJson} from "./FormatResponseDataJson";
import {HttpRequestWaitHandler} from "./HttpRequestWaitHandler";
import HttpRunTimeWatch from "./HttpRunTimeWatch";

export interface IFormatResponseData {
  getData(responseDto: any): any;
}

const defaultFormat = new FormatResponseDataJson();

export interface IErrorInfo {
  error: string;
}

export class Http {

  private waitHandler = new HttpRequestWaitHandler(null); // 默认空，不处理

  private headers: any = {
    Authorization: ""
  };

  public ax = axios.create({
    baseURL: "/",
    headers: this.headers,
    timeout: 30000
  });

  public ax2 = axios.create({
    baseURL: "/",
    headers: this.headers,
    timeout: 0
  })

  private formatResponse: IFormatResponseData;

  public constructor(formatResponse: IFormatResponseData = defaultFormat) {
    this.formatResponse = formatResponse;
    this.ax = axios.create({baseURL: "/", timeout: 120000});
    this.ax2 = axios.create({
      baseURL: "/",
      timeout: 0
    })
  }

  /** 设置等待处理器者 */
  public setWaitHandler(waitHandler: HttpRequestWaitHandler) {
    if (waitHandler == null) {
      throw new Error("setWaitHandler(waitHandler:参数不能为空)");
    }
    this.waitHandler = waitHandler;
  }

  public setheader = (newHeaders: any, timeout?: number) => {
    this.headers = {...this.headers, ...newHeaders};
    this.ax = axios.create({
      baseURL: "/",
      headers: this.headers,
      timeout: timeout || 60000
    });
    this.ax2 = axios.create({
      baseURL: "/",
      headers: this.headers,
    })
  };

  public get = (url: string, params?: any, opts?: any): Promise<any> => {
    const timeWatch = HttpRunTimeWatch.create(url);
    this.waitHandler.Start();
    return this.ax
      .get(url, {params, ...opts})
      .catch((error: any) => this.handleError(error, url))
      .then((responseDto: any) => this.formatData(responseDto, timeWatch, url));
  };

  public getOnly = (url: string, params?: any, opts?: any): Promise<any> => {
    this.waitHandler.Start();
    return this.ax.get(url, {params, ...opts}).catch((error: any) => this.handleError(error, url));
  };
  public getOnlyNoError = (url: string, params?: any, opts?: any): Promise<any> => {
    this.waitHandler.Start();
    return this.ax.get(url, {params, ...opts})
  };
  public post = (url: string, params?: any): Promise<any> => {
    const timeWatch = HttpRunTimeWatch.create(url);
    this.waitHandler.Start();
    return this.ax
      .post(url, params)
      .catch(error => this.handleError(error, url))
      .then(responseDto => this.formatData(responseDto, timeWatch, url));
  };
  public postParams = (url: string, params?: any): Promise<any> => {
    const timeWatch = HttpRunTimeWatch.create(url);
    this.waitHandler.Start();
    return this.ax({method: 'post', url, params})
      .catch(error => this.handleError(error, url))
      .then(responseDto => this.formatData(responseDto, timeWatch, url));
  };

  public postNotError = (url: string, params?: any): Promise<any> => {
    this.waitHandler.Start();
    return this.ax
      .post(url, params)
      .then((responseDto) => this.formatResponse.getData(responseDto))
  };

  public postNotThrowError = (url: string, params?: any): Promise<any> => {
    return this.ax
      .post(url, params)
      .catch(error => error.response)
      .then(responseDto => responseDto);
  };

  public postOnly = (url: string, params?: any, opts?: any): Promise<any> => {
    this.waitHandler.Start();
    return this.ax
      .post(url, params, opts)
      .catch(error => this.handleError(error, url))
      .then(responseDto => responseDto);
  };


  public currentUserOff(): void {
    this.headers = {};
    this.deleteCookie();
  }

  /** 不起作用，如果后端每请求自动生成Cookie */
  private deleteCookie = () => {
    document.cookie = "x-access-token=;Path=/;Expires=Fri, 25-Jan-2001 23:44:11 GMT;Max-Age=1;HttpOnly";
    document.cookie = "isLogin=flase;Path=/;Expires=Fri, 25-Jan-2001 23:44:11 GMT;Max-Age=1";
  };

  /** 进一步格式化数据 */
  private formatData = (responseDto: any, timeWatch: HttpRunTimeWatch, url: string) => {
    this.waitHandler.End();
    if (timeWatch != null) {
      timeWatch.finishWatch();
      console.log(timeWatch.GetRunTimeFormatText());
    }

    if (responseDto == null || responseDto.data == null) {
      return {};
    }

    /** 处理特殊code*/
    if (responseDto.data.code !== 0) {
      switch(Number(responseDto.data.code)) {
        case 10000:
          break;
        default:
          message.error(responseDto.data.msg || "网络错误");
      }
      throw new Error(url + "： 发生错误");
    }

    console.log(url + " ==> responseDto.data:", responseDto.data);
    const formatDto = this.formatResponse.getData(responseDto);
    return formatDto;
  };


  private handleError = (error: AxiosError, url: string) => {
    /** 刷新token */
    if (error.response && error.response.status === 401) {
      //window.ff.Socket.close();

      //refreshToken.refresh(error.config);
    } else {
      //this.NotifiedError(error, url);
    }
  };
}
